import React from 'react';
import { motion } from 'framer-motion';
const services = [{
  id: 'implantes',
  title: 'Implantes Dentales',
  desc: 'Restauración perfecta con tecnología 3D guiada para resultados definitivos y naturales.',
  img: 'https://cdn.magicpatterns.com/uploads/dLMHwiGc3cvLFpfaBLFA7C/Imagen_3.jpg'
}, {
  id: 'estetica',
  title: 'Estética Dental',
  desc: 'Carillas de porcelana ultrafinas diseñadas digitalmente para una sonrisa simétrica y deslumbrante.',
  img: 'https://cdn.magicpatterns.com/uploads/46ngsUNebdrHiT2eZr6vbT/Imagen_1.webp'
}, {
  id: 'ortodoncia',
  title: 'Ortodoncia Invisible',
  desc: 'Alineadores transparentes de última generación. Discretos, removibles y altamente efectivos.',
  img: 'https://cdn.magicpatterns.com/uploads/nKMouBBn84zpMoqK7t1cjm/Imagen_2.jpg'
}, {
  id: 'limpieza',
  title: 'Limpieza Profesional',
  desc: 'Terapia Airflow con agua y luz para una higiene profunda, indolora y blanqueamiento natural.',
  img: 'https://cdn.magicpatterns.com/uploads/c8KgjsQjL1XJQ4mZ9Va9WT/Imagen_3.jpg'
}];
export function Services() {
  return <section id="servicios" className="py-24 bg-night-800 relative z-20" data-id="element-92">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-93">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="mb-16" data-id="element-94">
          <h2 className="font-serif text-4xl md:text-5xl text-white mb-4" data-id="element-95">
            Nuestros Servicios{' '}
            <span className="text-gold italic" data-id="element-96">de Élite</span>
          </h2>
          <div className="w-24 h-1 bg-gold mb-6" data-id="element-97"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-98">
          {services.map((service, index) => <motion.div key={service.id} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="group relative h-[450px] md:h-[500px] rounded-xl overflow-hidden cursor-pointer" data-id="element-99">
              {/* Glow Effect Background */}
              <div className="absolute inset-0 bg-gold opacity-0 group-hover:opacity-20 blur-xl transition-opacity duration-700 z-0" data-id="element-100"></div>

              {/* Card Content */}
              <div className="relative z-10 w-full h-full border border-night-700 group-hover:border-gold/50 transition-colors duration-500 rounded-xl overflow-hidden bg-night-900" data-id="element-101">
                <div className="h-[70%] w-full overflow-hidden relative" data-id="element-102">
                  <div className="absolute inset-0 bg-gradient-to-t from-night-900 to-transparent z-10" data-id="element-103" />
                  <img src={service.img} alt={service.title} className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-1000" data-id="element-104" />
                </div>

                <div className="absolute bottom-0 left-0 right-0 p-8 z-20 bg-gradient-to-t from-night-900 via-night-900 to-transparent" data-id="element-105">
                  <h3 className="font-serif text-2xl text-white mb-2 group-hover:text-gold transition-colors duration-300" data-id="element-106">
                    {service.title}
                  </h3>
                  <p className="font-sans text-pearl/80 text-sm md:text-base opacity-0 group-hover:opacity-100 transform translate-y-4 group-hover:translate-y-0 transition-all duration-500" data-id="element-107">
                    {service.desc}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}